module.exports = __webpack_public_path__ + "static/media/miss-langtree.463cfe34.png";